var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9386 15.8152C17.8948 15.8152 16.7896 15.755 15.5002 15.5145C12.9827 15.0334 11.4477 13.7706 8.37771 14.372C1.62365 15.6949 -4.20939 34.7573 4.07968 34.9978C8.50051 35.1181 11.2021 30.1871 14.5792 28.9243C15.5002 28.5635 17.2808 28.3831 19 28.3831C20.7192 28.3831 22.4998 28.5635 23.4208 28.9243C26.7979 30.1871 29.4995 35.1181 33.9203 34.9978C42.2094 34.7573 36.3763 15.6949 29.6223 14.372C26.5523 13.7706 25.0173 15.0936 22.4998 15.5145C21.0876 15.755 19.9824 15.8152 18.9386 15.8152ZM18.9386 0C15.009 0 11.8161 3.12695 11.8161 6.97551C11.8161 10.8241 15.009 13.951 18.9386 13.951C22.8682 13.951 26.0611 10.8241 26.0611 6.97551C26.0611 3.12695 22.8682 0 18.9386 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIcon);
export default __webpack_public_path__ + "static/media/avatar-icon.f8cdee3dfa70813c6d4204e568331b9807611bbd26957736ad08da799948532e.svg";
export { ForwardRef as ReactComponent };